import { render, staticRenderFns } from "./Form2_Persona.vue?vue&type=template&id=4e3dfc7c"
import script from "./Form2_Persona.vue?vue&type=script&lang=js"
export * from "./Form2_Persona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dayanamartinez/Developer/laas_simulator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e3dfc7c')) {
      api.createRecord('4e3dfc7c', component.options)
    } else {
      api.reload('4e3dfc7c', component.options)
    }
    module.hot.accept("./Form2_Persona.vue?vue&type=template&id=4e3dfc7c", function () {
      api.rerender('4e3dfc7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Formularios/Formularios2/IMPACTA/Form2_Persona.vue"
export default component.exports